import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ProviderType } from '../../../../app/Slices/SevenDayApiTypes';
import { ModalProps } from '../../../types/modal';
import ContractorJobPreview from '../Jobs/ContractorJobPreview';
import OwnerJobPreview from './OwnerJobPreview';

interface JobPreviewProps extends ModalProps {
    id: number | null;
    jobIds?: { id: number; providerType: ProviderType }[];
    initialIndex?: number;
    onNavigate?: (nextIndex: number) => void;
}

const JobPreview = ({
    open,
    id,
    jobIds,
    initialIndex,
    onClose,
}: JobPreviewProps) => {
    const [searchParams, setSearchParams] = useSearchParams();

    if (!jobIds || !open) return null;

    const providerType = searchParams.get('provider-type');

    const navigate = (nextIndex: number) => {
        const nextId = jobIds?.[nextIndex];
        if (nextId == null) return;
        const next = new URLSearchParams(searchParams);
        next.set('selectedJob', String(nextId.id));
        next.set('provider-type', nextId.providerType);
        setSearchParams(next, { replace: true });
    };

    return providerType === ProviderType.Contractor ? (
        <ContractorJobPreview
            open={open}
            id={id}
            jobIds={jobIds}
            initialIndex={initialIndex}
            onClose={onClose}
            onNavigate={navigate}
        />
    ) : (
        <OwnerJobPreview
            open={open}
            id={id}
            jobIds={jobIds}
            initialIndex={initialIndex}
            onClose={onClose}
            onNavigate={navigate}
        />
    );
};

export default JobPreview;
